import { render, staticRenderFns } from "./Configuracao.vue?vue&type=template&id=78b416f0&scoped=true"
import script from "./Configuracao.vue?vue&type=script&lang=js"
export * from "./Configuracao.vue?vue&type=script&lang=js"
import style0 from "./Configuracao.vue?vue&type=style&index=0&id=78b416f0&prod&lang=scss&scoped=true"
import style1 from "./Configuracao.vue?vue&type=style&index=1&id=78b416f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b416f0",
  null
  
)

export default component.exports